import { useQuery } from "react-query";
import { QueryReturnType, client } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export const useGetAuthAuditLogDetail = (
  id: string | null,
  includePassword: boolean = false
): QueryReturnType<any> => {
  return useQuery<any, never, any>(
    [ENDPOINTS.AUTH_AUDIT_LOG_DETAIL, id, includePassword],
    async () => {
      const url = `${ENDPOINTS.AUTH_AUDIT_LOGS}/${id}${includePassword ? "?includePassword=true" : ""}`;
      const { data } = await client.get(url);
      return data;
    },
    {
      enabled: !!id,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      staleTime: 0,
      cacheTime: 0,
    }
  );
};
